export default "__VITE_ASSET__D3EeJ2Q2__"